import { createDefaultMutationHook } from "hooks/useMutationHandler";
import { MutationHandlerOptions } from "types/Mutation";

import {
  USER_GUIDE_START,
  USER_GUIDE_MOVE_TO_NEXT_STEP,
  USER_GUIDE_COMPLETE,
  USER_GUIDE_ABANDON,
  USER_GUIDE_RESTART,
  GET_USER_GUIDE_PROGRESS,
  GET_USER_GUIDE_GROUP,
  GET_USER_GUIDE_GROUPS,
  GET_MISSION_CONTROL_DATA,
  USER_GUIDE_MOVE_TO_PREVIOUS_STEP,
} from "./gql";

const REFETCH_QUERIES = [
  GET_USER_GUIDE_PROGRESS,
  GET_USER_GUIDE_GROUP,
  GET_USER_GUIDE_GROUPS,
  GET_MISSION_CONTROL_DATA,
];

const useStartUserGuideMutation = createDefaultMutationHook(USER_GUIDE_START);
const useMoveToNextStepMutation = createDefaultMutationHook(USER_GUIDE_MOVE_TO_NEXT_STEP);
const useMoveToPreviousStepMutation = createDefaultMutationHook(USER_GUIDE_MOVE_TO_PREVIOUS_STEP);
const useCompleteUserGuideMutation = createDefaultMutationHook(USER_GUIDE_COMPLETE);
const useAbandonUserGuideMutation = createDefaultMutationHook(USER_GUIDE_ABANDON);
const useRestartUserGuideMutation = createDefaultMutationHook(USER_GUIDE_RESTART);

type UseUserGuideProgressMutationsOptions = Pick<
  MutationHandlerOptions<unknown, unknown>,
  "propagateError" | "suppressFlashError"
>;

const useUserGuideProgressMutations = (options?: UseUserGuideProgressMutationsOptions) => {
  const mutationOptions = { refetchQueries: REFETCH_QUERIES, ...options };

  const [startUserGuide] = useStartUserGuideMutation(mutationOptions);
  const [moveToNextStep] = useMoveToNextStepMutation(mutationOptions);
  const [moveToPreviousStep] = useMoveToPreviousStepMutation(mutationOptions);
  const [completeUserGuide] = useCompleteUserGuideMutation(mutationOptions);
  const [abandonUserGuide] = useAbandonUserGuideMutation(mutationOptions);
  const [restartUserGuide] = useRestartUserGuideMutation(mutationOptions);

  return {
    startUserGuide,
    moveToNextStep,
    moveToPreviousStep,
    completeUserGuide,
    abandonUserGuide,
    restartUserGuide,
  };
};

export default useUserGuideProgressMutations;
